
import { useLeafletContext } from "@react-leaflet/core";
import "@geoman-io/leaflet-geoman-free";
import "@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css";
import  { useEffect} from 'react';
import NiceModal from '@ebay/nice-modal-react';
import tokml from "tokml";
const MapControls = ({modal}) => {
  const context = useLeafletContext();
  useEffect(() => {
    const leafletContainer = context.layerContainer || context.map;
    leafletContainer.pm.addControls({
      position: 'topright',
      drawMarker: false,
      drawCircle: false,
      drawCircleMarker: false,
      drawText:false,
      editable: false,
    });
    leafletContainer.pm.setGlobalOptions({ pmIgnore: false });
    leafletContainer.on("pm:create", (e) => {
      if (e.layer && e.layer.pm) {
        
        const shape = e;
       //
        shape.layer.pm.enable();
       
        console.log(leafletContainer.pm.getGeomanLayers(true).toGeoJSON());
        var kml = tokml(leafletContainer.pm.getGeomanLayers(true).toGeoJSON());
          const blob = new Blob([kml], { type: "application/vnd.google-earth.kml+xml" });
          const file = new File([blob], "farm.kml", { type: "application/vnd.google-earth.kml+xml" });
        
        NiceModal.show(modal,{ location: file, farm_location:e.layer.toGeoJSON() })
        
      }
    });
    leafletContainer.on("pm:remove", (e) => {
      console.log("object removed");
     });
    return () => {
      leafletContainer.pm.removeControls();
      leafletContainer.pm.setGlobalOptions({ pmIgnore: true });
    };
  }, [context,modal]);
  return null;
};
export default MapControls;